import React, { useState } from "react";

const CourseNav = () => {
  const sections = [
    { id: "overview", label: "Overview" },
    { id: "keyFocus", label: "Key Focus" },
    { id: "expectedOutcomes", label: "Outcomes" },
    { id: "programmeFormat", label: "Format" },
    { id: "cost", label: "Cost" },
    { id: "contactUs", label: "Contact Us" },
    { id: "applyNow", label: "Apply Now" },
  ];
  const [activeSection, setActiveSection] = useState("overview");
  const handleNavClick = (sectionId) => {
    setActiveSection(sectionId);
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div className="sticky top-[68px] md:top-28 z-20">
      <div className="bg-[#6089B5] py-4 shadow block lg:hidden">
        <ul className="flex space-x-2 sm:justify-center overflow-x-auto whitespace-nowrap">
          {sections.map((section) => (
            <li key={section.id}>
              <div className="p-2 rounded-md text-sm">
                <a
                  href={`#${section.id}`}
                  onClick={(e) => {
                    e.preventDefault();
                    handleNavClick(section.id);
                  }}
                  className={`p-2 rounded-md ${
                    activeSection === section.id
                      ? "bg-[#498ED8] text-white"
                      : "bg-gray-300"
                  }`}
                >
                  {section.label}
                </a>
              </div>
            </li>
          ))}
        </ul>
      </div>
      <div className="bg-[#6089B5] p-4 shadow hidden lg:block">
        <ul className="flex justify-center space-x-4">
          {sections.map((section) => (
            <li key={section.id}>
              <div>
                <a
                  href={`#${section.id}`}
                  onClick={(e) => {
                    e.preventDefault();
                    handleNavClick(section.id);
                  }}
                  className={`p-2 rounded-md ${
                    activeSection === section.id
                      ? "bg-[#498ED8] text-white border-2 border-white"
                      : "bg-gray-300"
                  }`}
                >
                  {section.label}
                </a>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default CourseNav;
